const PAGE_SECTIONS = {
  '/pages/help': {
    'shipping policy': 'shipping-policy',
    'return & refund policy': 'return-refund-policy',
    'contact information': 'contact-information',
    'frequently asked questions': 'faqs',
  },
  '/pages/about-us': {
    'our belief': 'belief-system',
    'our philosophy': 'our-philosophy',
    'our mission': 'our-mission',
    'about us': 'about-livelier',
  },
  '/pages/legal': {
    'terms of service': 'terms-conditions',
    'privacy policy': 'privacy-policy',
    'purchase & fulfillment policy': 'purchase-fulfillment-policy',
  },
};

function ensurePageAnchors() {
  const sections = PAGE_SECTIONS[window.location.pathname];
  if (!sections) return;

  document.querySelectorAll('h1, h2, h3, .text-block p').forEach((heading) => {
    const anchor = sections[heading.textContent.trim().toLowerCase()];
    if (!anchor) return;

    heading.id = anchor;
    heading.style.scrollMarginTop = '100px';
  });
}

function scrollToPageSection(hash, behavior = 'smooth') {
  if (!hash) return false;

  ensurePageAnchors();

  const target = document.getElementById(decodeURIComponent(hash.slice(1)));
  if (!target) return false;

  target.scrollIntoView({ behavior, block: 'start' });
  return true;
}

document.addEventListener('click', (event) => {
  const link = event.target instanceof Element ? event.target.closest('a[href*="/pages/"][href*="#"]') : null;
  if (!link) return;

  const url = new URL(link.href, window.location.origin);
  if (!PAGE_SECTIONS[url.pathname] || window.location.pathname !== url.pathname) return;

  event.preventDefault();
  history.pushState(null, '', `${url.pathname}${url.search}${url.hash}`);
  scrollToPageSection(url.hash);
});

function restorePageAnchor() {
  if (!PAGE_SECTIONS[window.location.pathname] || !window.location.hash) return;

  ensurePageAnchors();
  requestAnimationFrame(() => {
    requestAnimationFrame(() => scrollToPageSection(window.location.hash, 'auto'));
  });

  setTimeout(() => scrollToPageSection(window.location.hash, 'auto'), 250);
  setTimeout(() => scrollToPageSection(window.location.hash, 'auto'), 750);
}

document.addEventListener('DOMContentLoaded', restorePageAnchor);
window.addEventListener('pageshow', restorePageAnchor);
window.addEventListener('popstate', restorePageAnchor);
